import React from 'react';
import { MenuItem } from '@fiverr-private/dropdown';
import { CloseAction } from '../../types';
import { AppI18n } from '../../i18n';

interface CloseBriefButtonProps {
  closeAction: CloseAction;
  onClick?: () => void;
}

export const CloseBriefButton = ({ closeAction, onClick }: CloseBriefButtonProps) => (
  <MenuItem onClick={onClick}>
    <AppI18n k={`options_menu.${closeAction}`} />
  </MenuItem>
);
